import { Outlet } from 'react-router-dom';
import { Sidebar } from '@/components/Sidebar';

/**
 * Authenticated layout: fixed 200px sidebar + content area offset by 200px,
 * matching AST2's `.header` / `.body` split (css/style.css).
 */
export function AppShell() {
  return (
    <div className="ast-app">
      <Sidebar />
      <main className="ast-body">
        <Outlet />
      </main>
    </div>
  );
}
